module.exports = __webpack_public_path__ + "img/DiHS_Video_Icon_Lu_Meldung1.4593102c.png";